/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { VendorListModel } from '@well/domain';
import { ShipmentDtoModel } from '../index';

export class ShipmentVendorTemplateDTO extends ShipmentDtoModel {

  requestingCompanyLeUuid: string | undefined = undefined;

  vendors: VendorListModel[] = [];
}

